import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '50rem',
    justifyContent: 'center',
  },
  error: {
    fontSize: 70,
    margin: 0,
    marginBottom: '1rem',
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
  },
  message: {
    fontSize: 20,
    marginLeft: '1rem',
    marginTop: '1rem',
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
